import { render } from "./profile.vue?vue&type=template&id=792fb712"
const script = {}
script.render = render

export default script